<template>
  <table class="app-calendar-table">
    <thead>
      <tr>
        <td>S</td>
        <td>M</td>
        <td>T</td>
        <td>W</td>
        <td>T</td>
        <td>F</td>
        <td>S</td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(week, i) in dates" :key="i">
        <td
          v-for="(day, j) in week"
          :key="`${i}-${j}`"
          :class="getCellClass(day)"
          @click.stop.prevent="select(day)"
          @touchend.stop.prevent="select(day)"
          @mousedown.prevent
        >
          <span class="label">{{ day.label }}</span>
          <div class="cell-mark"></div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'AppCalendarTable',
  props: {
    firstDayOfActiveMonth: {
      type: Object,
      default: () => {
        return dayjs().date(1)
      }
    },
    activeDate: {
      type: Object,
      default: null
    },
    marksMap: {
      type: Map,
      default: () => {
        return new Map()
      }
    },
    marksFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    isDateSelectable: {
      type: Function
    }
  },
  data: () => ({
    today: dayjs()
  }),
  computed: {
    dates() {
      let dates = []
      let date = this.firstDayOfActiveMonth.subtract(this.firstDayOfActiveMonth.day(), 'day')
      for (let i = 0; i < 6; i++) {
        let weekDays = []
        for (let j = 0; j < 7; j++) {
          weekDays.push({ label: date.date(), date })
          date = date.add(1, 'day')
        }
        dates.push(weekDays)
      }
      return dates
    }
  },
  methods: {
    getCellClass(cellDay) {
      const classes = [cellDay.date.isSame(this.activeDate, 'date') ? ' selected' : '']

      if (cellDay.date.isAfter(this.today, 'date')) {
        classes.push('future')
      } else if (cellDay.date.isSame(this.today, 'date')) {
        classes.push('today')
      } else {
        classes.push('past')
      }

      const cellInMarkFormat = cellDay.date.format(this.marksFormat)
      if (this.marksMap.has(cellInMarkFormat)) {
        classes.push('marked')
      }

      const selectable = this.isDateSelectable?.(cellDay) ?? true

      if (!selectable) {
        classes.push('non-selectable')
      }

      return classes.join(' ')
    },
    select(day) {
      this.$emit('select', day)
    }
  }
}
</script>

<style scoped lang="scss">
.app-calendar-table {
  text-align: center;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  font-size: inherit;
  margin-top: 4px;
  position: relative;
  padding-bottom: 10px;

  & tbody td {
    cursor: pointer;
  }

  & td {
    position: relative;
    width: 28px;
    height: 28px;

    &.past {
      opacity: 0.9;
    }

    &.marked .cell-mark {
      display: block;
    }

    &.today.marked .cell-mark {
      background: #0f0f0f;
      right: 0;
    }

    &.today {
      color: #fff;

      &:after {
        content: ' ';
        background: #0b76b8;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 0;
        margin: 2px 1px 1px 2px;
        z-index: 1;
      }

      & .label {
        position: relative;
        z-index: 2;
      }
    }
  }

  .selected,
  .future:hover:not(.non-selectable) {
    background: #e5e5e5;
  }

  .non-selectable {
    opacity: 0.5;
  }

  .cell-mark {
    display: none;
    position: absolute;
    right: 2px;
    top: 2px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #0b76b8;
  }
}
</style>
